import { cx } from "@/utils";
import SpinnerAnimated from "@components/SpinnerAnimated";

const Spinner = ({ style = {}, className = "" }) => {
  return (
    <SpinnerAnimated className={cx("w-10 h-10", className)} style={style} />
  );
};

export default Spinner;
